var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{class:{ bold: _vm.name === '개인정보처리방침' },attrs:{"data-footer-nav":"","href":_vm.to,"rel":"noopener noreferrer","target":"_blank"}},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }